var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { connect } from 'react-redux';
import { Translate } from "../../I18N";

import { SettingsHeader } from "./SettingsHeader";

const formatBytes = (bytes) => {
  //Sourced from https://stackoverflow.com/questions/15900485
  if (!+bytes || +bytes < 0) return '0 Bytes';
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${parseFloat((bytes / 1024 ** index).toFixed(2))} ${sizes[index]}`;
};

const mapStateToProps = (state) => ({
  stats: state.settings.stats
});

const connector = connect(mapStateToProps);



const DashboardComponent = ({ stats }) => {
  if (!stats) {
    return /*#__PURE__*/_jsx("div", {});
  }

  const storage = formatBytes(stats.get('storage').get('total'));
  const [adminUsers, editorUsers, collaboratorUsers] = [
  stats.get('users').get('admin'),
  stats.get('users').get('editor'),
  stats.get('users').get('collaborator')];


  return /*#__PURE__*/(
    _jsx("main", { className: "settings-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "settings-dashboard" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel-default" }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Dashboard")), /*#__PURE__*/

    _jsx("div", { className: "panel-body" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "cards" }, void 0, /*#__PURE__*/
    _jsx("article", { className: "card" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "heading" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Users"))), /*#__PURE__*/



    _jsx("div", { className: "body" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, stats.get('users').get('total'), " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Total users")), /*#__PURE__*/

    _jsx("div", { className: "footer" }, void 0,
    adminUsers > 0 && /*#__PURE__*/
    _jsx("p", { className: "user-info" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, adminUsers, " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Admin")),


    editorUsers > 0 && /*#__PURE__*/
    _jsx("p", { className: "user-info" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, editorUsers, " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Editor")),


    collaboratorUsers > 0 && /*#__PURE__*/
    _jsx("p", { className: "user-info" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, collaboratorUsers, " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Collaborator")))), /*#__PURE__*/





    _jsx("article", { className: "card" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "heading" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Storage"))), /*#__PURE__*/



    _jsx("div", { className: "body" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, storage)), /*#__PURE__*/


    _jsx("div", { className: "footer card-info" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "card-info" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Files and database usage")))), /*#__PURE__*/




    _jsx("article", { className: "card" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "heading" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Entities"))), /*#__PURE__*/



    _jsx("div", { className: "body" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, stats.get('entities').get('total'), " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Total entities")), /*#__PURE__*/


    _jsx("div", { className: "footer card-info" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "card-info" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Entities across all languages")))), /*#__PURE__*/




    _jsx("article", { className: "card" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "heading" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Files"))), /*#__PURE__*/



    _jsx("div", { className: "body" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "count" }, void 0, stats.get('files').get('total'), " "), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Total files")), /*#__PURE__*/


    _jsx("div", { className: "footer card-info" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "card-info" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Total files from main documents, supporting files and custom uploads"))))))))));











};

const container = connector(DashboardComponent);
export { container as Dashboard };